import { useMemo } from 'react';

import uuid from 'pkg/uuid';

const useUuid = (): string => useMemo(() => uuid(), []);

export default useUuid;
